
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/tutors",
      function () {
        return require("private-next-pages/explore/tutors.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/tutors"])
      });
    }
  